import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Header, Icon, Segment } from 'semantic-ui-react';

const NotFoundForAdmin = () => {
  return (
    <Segment placeholder>
      <Header icon>
        <Icon name='search' />
        ページがみつかりませんでした
      </Header>
      <Segment.Inline>
        <Button as={Link} to='/admin' primary>
          トップページに戻る
        </Button>
      </Segment.Inline>
    </Segment>
  );
};

export default NotFoundForAdmin;
